import axios from 'axios';

class L10n {
	handleVars = [
	    'brand_name',
	    'deliverable',
	    'talent_name',
	    'talent_name_singular',
	    'deliverable_plural',
	    'talent_name_plural',
	    'custom_sample_name_singular',
	    'custom_sample_name_plural',
	    'deliverable_type',
	    'call_action',
	];

	constructor(siteLocale = 'en', projectFolder = '/widget', categoryId = 'voice_over', baseUrl, url) {
	    this.siteLocale = siteLocale;
	    this.projectFolder = projectFolder;
	    this.categoryId = categoryId;
        this.baseUrl = baseUrl;
		this.url = url;
		this.dictionary = {};
	    this.promise = new Promise((resolve, reject) => {
	        this.resolve = resolve;
	        this.reject = reject;
        });
		this.categoriesRegex = new RegExp('{{('+this.handleVars.join('|')+')}}','gi');
	    this.getTranslationJson();
	}

	getTranslation(locale, str, dictionary) {
	    return dictionary?.[str] || str;
	}

	cleanHandleBar(handleBar) {
        handleBar = handleBar.replace('{{', '');
        handleBar = handleBar.replace('::', '');
        handleBar = handleBar.replace('category.', '');
        handleBar = handleBar.replace('}}', '');
        return handleBar;
	}

	resolveCategoryHandlebars(text, category) {
        let tempText = this.siteLocale !== 'en' ? this.getTranslation(this.siteLocale, text, this.dictionary) : text;
        const categoryHandlebars = tempText.match(this.categoriesRegex);
        
        if(categoryHandlebars) {
            categoryHandlebars.forEach(categoryHandlebar => {
                const fixedCategoryHandlebar = this.cleanHandleBar(categoryHandlebar);
                const translatedHandlebar = tempText == text ? category[fixedCategoryHandlebar] : this.getTranslation(this.siteLocale, category[fixedCategoryHandlebar], this.dictionary);
                tempText = tempText.replace(categoryHandlebar, translatedHandlebar);
            });
        }

        return tempText;
	}

	getString(str, category = {}, replaceObject = undefined) {
        if (typeof str !== 'string') {
            return str;
        }

        try {
			if (Object.keys(category).length !== 0) {
				str = this.resolveCategoryHandlebars(str, category);
			}
            str = this.siteLocale === 'en' ? str : this.getTranslation(this.siteLocale, str, this.dictionary);

            if (replaceObject) {
                str = Object.keys(replaceObject).reduce((acc, cur) => this.replacePlaceholder(acc, cur, replaceObject), str);
            }
        } catch(err) {
            console.error(err);
        }
	    return str;
	}

	replacePlaceholder(text, key, replaceObject) {
	    return text.replace(new RegExp(`{{${key}}}`, 'g'), replaceObject[key]);
	}

	async getTranslationJson() {
	    if (this.siteLocale !== 'en') {
			const mainUrl = this.url ?? window.location.host;
			const cdnDomain = 'd2kcd4y6vw7b6c.cloudfront.net';
				// mainUrl.includes('local.') || mainUrl.includes('dev.') ? 'dx7dafuy8g98k.cloudfront.net' : 'd2kcd4y6vw7b6c.cloudfront.net';
            const url = `https://${cdnDomain}/l10n-manager/widget/${this.siteLocale}-default.json`;

            try {
                const response = await axios.get(url);
				const { data } = response;

                this.dictionary = data.dic || data;
	            this.resolve();
	        } catch (error) {
	            console.error(error);
	        }
	    } else {
	        this.resolve();
	    }
	}
}

export default L10n;
